export default __webpack_public_path__ + "static/media/1516 utensils top.93edfc99.png";